import { createStore } from "vuex";

const projectStore = createStore({
  state: {
    major: [
      {
        link: "https://github.com/Eve-ning/FRModel",
        title:
          'FRModel <i class="bi bi-github"></i> <i class="fab fa-python"></i>',
        body: `<p>My current research project. Using unmanned drone data to
              classify trees. The data consists of 2D Multi-spectral & 3D Point Cloud data,
              we estimate tree health as much as possible.</p>

              <p>My main contribution is to create a unifying package for team researchers,
               and also contributing to experiments.</p>

              <p><i>The first phase of the project ended in <b>June 2021.</b></i></p>`,
        footer: `<p>Languages: Python.<br/>
                   Wiki Framework: Sphinx</p>`,
      },
      {
        link: "https://github.com/Eve-ning/reamber",
        title: 're:amber <i class="bi bi-github"></i> C++, C',
        body: `<p>An osu! SV/BPM mapping tool that evolved from CLI to a GUI tool.</p>
               <p>Dusting off this ancient artifact of a program, I recreated re:amber using
               a more flexible framework Qt. </p>
               <p>It has a long history and one of the main reasons why I program.</p>
               <p>Currently, <span class="font-monospace">re:amberPy</span> is being developed.</p>`,
        footer: `<p>Languages: C, C++.<br/>
                   Framework: Qt</p>`,
      },
      {
        link: "https://github.com/Eve-ning/reamberPy",
        title:
          're:amberPy <i class="bi bi-github"></i> <i class="fab fa-python"></i>',
        body: `<p>This is a <b>Python</b> package expected to cover most VSRG formats,
               including: <span class="font-monospace">.osu .sm .ojm .bms .qua</span></p>
               <p>The aim is to create an <b>open-source</b> library that VSRG
               programmers use to improve their Python skills while enjoying the game.</p>
               <p>This is still under developement.</p>`,
        footer: `<p>Languages: Python.<br/>
                   Wiki Framework: Sphinx</p>`,
      },
      {
        link: "https://evening-osu.herokuapp.com/analytics/render/",
        title: `Django - re:amberPy <i class="bi bi-github"></i>\n
                  <i class="fab fa-python"></i> <i class="fab fa-bootstrap"></i> <i class="fab fa-html5"></i>\n
                  <i class="fas fa-cloud"></i>`,
        body: `<p>Using Django, I pivot off of <span class="font-monospace">re:amberPy</span>
               to create an online tool hosted by Heroku.</p>`,
        footer: `<p>Languages: Python.<br/>
                   Web Framework: Django.<br/>
                   HTML Framework: Bootstrap 5.<br/>
                   Host: Heroku / Microsoft Azure</p>`,
      },
      {
        link: "/",
        title: `This Website <i class="fab fa-bootstrap"></i> <i class="fab fa-html5"></i>
                  <i class="fas fa-cloud"></i> <i class="fab fa-vuejs"></i> <i class="fab fa-js"></i>`,
        body: `<p>Using Bootstrap 5, I made this website from scratch :)</p>
               <p>Not a fan of web development, but I'm proud of what I have done here.</p>
               <p>Special Thanks to
               <a class="text-primary text-decoration-none" href="https://twitter.com/IceDynamix">IceDynamix</a>
               for introducing me to Vue!</p>`,
        footer: `<p>Languages: HTML, CSS, JS<br/>
                   HTML Framework: Bootstrap 5, Vue.JS.</p>`,
      },
      {
        link: "https://share.streamlit.io/eve-ning/streamlit-example/analysis.py",
        title: `Streamlit - re:amberPy <i class="bi bi-github"></i>\n
                  <i class="fab fa-python"></i> <i class="fab fa-bootstrap"></i> <i class="fab fa-html5"></i>\n
                  <i class="fas fa-cloud"></i>`,
        body: `<p>Using Streamlit, with <span class="font-monospace">re:amberPy</span>
               I create another online tool hosted by Streamlit Cloud!</p>`,
        footer: `<p>Languages: Python.<br/>
                   Web Framework: Django.<br/>
                   HTML Framework: Bootstrap 5.<br/>
                   Host: Heroku / Microsoft Azure</p>`,
      },
    ],
    minor: [
      {
        link: "https://github.com/Eve-ning/vsrgtools",
        body: "vsrg-tools: R-Variant of re:amberPy",
      },
      {
        link: "https://github.com/Eve-ning/sv-tool",
        body: "sv-tool: Ancient C++ CLI of re:amberPy",
      },
      {
        link: "https://github.com/Eve-ning/ARXScore",
        body: "ARXScore: An XGBoost estimator for VSRG map difficulty estimation",
      },
      {
        link: "https://github.com/Eve-ning/aleph0",
        body: "aleph-0: Python code used to generate the visual Beatmap Aleph-0 Extended By LeaF.",
      },
      {
        link: "https://github.com/Eve-ning/numpy_as_strided_guide",
        body: `numpy_as_strided_guide: A LaTeX Document on how NumPy
                 <span class="font-monospace">as_strided</span> operates`,
      },
      {
        link: "https://github.com/Eve-ning/ppshift_ml",
        body: "ppshift_ml: An early approach on map difficulty estimation using DNNs.",
      },
      {
        link: "https://github.com/Eve-ning/SV-Crash-Course-LaTeX",
        body: "SV-Crash-Course-LaTeX: A LaTeX document tutorial on how SVs in osu! operate.",
      },
    ],
    motive: [
      {
        title: "Time",
        body:
          "<p>Saving 10 seconds isn't impressive.</p>" +
          "<p>But cumulatively, if it saved days of work, it's worthwhile.</p>",
      },
      {
        title: "Create",
        body:
          "<p>Pioneering the invention is euphoric.</p>" +
          "<p>Much more so if it drove derivations.</p>",
      },
      {
        title: "Experiment",
        body: "<p>I enjoy data experiments, testing theories and hypotheses.</p>",
      },
    ],
  },
  mutations: {},
  actions: {},
  modules: {},
});

export default projectStore;
